import { api } from "api";

/**
 * Review moderation + vendor portal API client. Wraps the
 * /api/reviews/* endpoints documented in
 * talabatk-data/plans/reviews-and-ratings/design/03-api-endpoints.md.
 *
 * Admin endpoints require the manage_reviews permission (or super_admin).
 * Vendor portal endpoint requires role='vendor'. Both are enforced
 * server-side; this client doesn't gate.
 */

// ─── admin moderation ─────────────────────────────────────────────────────

export const listAdminReviews = async (params = {}) => {
    const response = await api.get("api/reviews/admin", { params });
    return response.data;
};

export const getAdminReviewById = async (id) => {
    const response = await api.get(`api/reviews/admin/${id}`);
    return response.data;
};

export const setReviewStatus = async (id, status) => {
    const response = await api.patch(`api/reviews/admin/${id}/status`, { status });
    return response.data;
};

export const listAdminVendorReviews = async (vendorId, params = {}) => {
    const response = await api.get(`api/reviews/admin/vendor/${vendorId}`, { params });
    return response.data;
};

export const listAdminProductReviews = async (productId, params = {}) => {
    const response = await api.get(`api/reviews/admin/product/${productId}`, { params });
    return response.data;
};

export const listAdminDeliveryReviews = async (userId, params = {}) => {
    const response = await api.get(`api/reviews/admin/delivery/${userId}`, { params });
    return response.data;
};

export const listAdminOrderReviews = async (orderId) => {
    const response = await api.get(`api/reviews/admin/order/${orderId}`);
    return response.data;
};

export const recomputeAllReviewAggregates = async () => {
    const response = await api.post("api/reviews/admin/recompute-all");
    return response.data;
};

// ─── vendor portal ────────────────────────────────────────────────────────

export const getVendorPortalReviews = async (params = {}) => {
    const response = await api.get("api/reviews/vendor-portal", { params });
    return response.data;
};
